import React from "react";
import WorkOrderStatus from "../../components/WorkOrderStatus";
import dayjs from "dayjs";
import { WorkOrderStatusType } from "../../utils/enum";
import BaseTooltip from "../../components/ui/BaseTooltip";

const TitleCard = ({
  title,
  id,
  publishedDate,
  status,
  subStatus,
  customerSubStatus,
  subStatusText,
  customerStatus,
  fromCustomerBoard,
  isPOPending,
}) => {
  return (
    <div className="grid grid-cols-10 items-center w-full h-full">
      <div className="xl:col-span-9 col-span-10 flex items-center">
        <div className="">
          <div className="flex items-center flex-wrap gap-y-1">
            {/* customerStatus is only set from approval onwards (APPROVED, INVOICED,
                PAID, CANCELLED_PAYABLE). Before that it is null, so fall back to the
                work order status — otherwise the badge renders empty on the customer
                board for every earlier stage. */}
            <WorkOrderStatus
              status={fromCustomerBoard ? (customerStatus ?? status) : status}
              textSize="text-sm"
              width="w-28"
              className="py-[4px]"
            />
            {(subStatus || customerSubStatus) && (
              <>
                <div className="ml-1">
                  {isPOPending ? (
                    <>
                      {" "}
                      <div className="flex items-center gap-2">
                        <i className="fa-regular fa-arrow-right-long text-primary"></i>

                        <div className="table-font-size truncate max-w-72">
                          <WorkOrderStatus
                            status={subStatus}
                            className="!py-[4px] !min-w-[100px] !w-auto !px-3 whitespace-nowrap"
                          />
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="flex items-center gap-2">
                        <i className="fa-regular fa-arrow-right-long text-primary"></i>

                        <BaseTooltip
                          position="bottom"
                          interactive={true}
                          content={
                            <div className="relative pb-2">
                              <p className="text-white">{subStatusText}</p>
                            </div>
                          }
                        >
                          <div className="table-font-size truncate max-w-72">
                            <WorkOrderStatus
                              status={
                                fromCustomerBoard
                                  ? (customerSubStatus ?? subStatus)
                                  : status === WorkOrderStatusType.CANCELLED
                                    ? customerStatus
                                    : subStatus
                              }
                              className="!py-[4px] !min-w-[100px] !w-auto !px-3 whitespace-nowrap"
                              // The surrounding tooltip already describes this
                              // sub-status; a second one on the badge would flicker.
                              tooltip={false}
                            />
                          </div>
                        </BaseTooltip>
                      </div>
                    </>
                  )}
                </div>
              </>
            )}
            <div className="flex items-end">
              <h6 className="font-normal ml-2">#{id}</h6>
              <p className="ml-2  ">On {dayjs(publishedDate).format("MM/DD/YYYY")}</p>
            </div>
          </div>
          <h6 className="font-normal mt-2">{title}</h6>
        </div>
      </div>
      <div className="border-r-[1px]  border-zinc-300 mr-6 h-20 xl:block hidden"></div>
    </div>
  );
};

export default TitleCard;
